namespace advisorop.components.meetinghub {
    export class MeetingDocumentsController {
        documents: Array<domains.IDmsDocument>;
        participant: domains.IMeetingParticipant;
        meetingGuid: string;
        meetingId: number;
        household: domains.IHousehold;

        activeTab: number = 0;
        user: domains.IUser;
        isAdvisorUser: boolean = false;
        documentChangeCallbackToken: string;


        constructor(private meetingHubService: services.MeetingHubService, private identityService: services.IdentityService,
                private docChanges: factories.MeetingHubSignalR, private $scope: ng.IScope) {

        }

        setupDocumentChangeCallback(): void {
            if (this.documentChangeCallbackToken != undefined) {
                return;
            }

            this.documentChangeCallbackToken = this.docChanges.OnDocumentChanges(this.meetingGuid, (meetingGuid) => {
                if (this.meetingGuid == meetingGuid) {
                    this.getMeetingDocuments();
                }
            });

            if (this.docChanges.GetConnectionState() == signalR.HubConnectionState.Disconnected) {
                this.docChanges.Start().then(() => {
                    this.joinDocumentChangeGroup();
                })
            } else {
                this.joinDocumentChangeGroup();
            }

            this.$scope.$on("$destroy", () => {
                if (this.documentChangeCallbackToken != undefined) {
                    this.docChanges.RemoveOnDocumentChanges(this.meetingGuid, this.documentChangeCallbackToken);
                    this.documentChangeCallbackToken = undefined;
                }
            })
        }

        joinDocumentChangeGroup(): void {
            if (this.docChanges.GetConnectionState() == signalR.HubConnectionState.Connected) {
                this.docChanges.Group(this.meetingGuid);
            }
        }

        allFilesUploaded(): void {
            this.activeTab = 0;
        }

        documentDelete(): void {
            this.getMeetingDocuments();
        }

        getMeetingDocuments(): void {
            var participantGuid = "NoParticipant";

            if (this.participant != undefined) {
                participantGuid = this.participant.guid;
            }

            this.meetingHubService.getDocuments(this.meetingGuid, participantGuid).then(resp => {
                this.documents = [];
                this.documents = resp.data.concat();
                console.log(resp);
            });
        }

        showUpload(): boolean {
            var ret = false;
            if (this.participant != undefined) {
                ret = this.participant.isHost;
            } else {
                ret = this.isAdvisorUser;
            }
            return ret;
        }

        $onInit(): void {
            this.user = this.identityService.getUser();

            this.isAdvisorUser = (
                this.user.role === "ADVISORY"
                || this.user.role === "ADVISORY_LEAD"
                || this.user.role === "ADVISORY_ADMIN"
            );
        }

        $onChanges(evt): void {
            if (evt.meetingGuid != undefined) {
                if (evt.meetingGuid.previousValue != evt.meetingGuid.currentValue && this.meetingGuid) {
                    this.getMeetingDocuments();
                    this.setupDocumentChangeCallback();
                }
            }
        }
    }

    class MeetingDocuments implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                participant: '<',
                meetingGuid: '<',
                meetingId: '<',
                household: '<',
            };
            this.controller = [`meetingHubService`, `identityService`, 'MeetingHubSignalR', '$scope', MeetingDocumentsController];
            this.controllerAs = `vm`;
            this.templateUrl = `spa/meeting-hub-module/components/meeting-documents.html`;
        }
    }
    angular.module(Constants.APP).component(`meetingDocuments`, new MeetingDocuments());
}